<template>
  <v-app-bar
    app
    fixed
    :extended="!isMobile"
    color="#f5f5f59c"
  >
    <v-toolbar-title>
      <router-link to="/">
        <v-img
          :class="isMobile ? 'mobileLogo' : 'logo'"
          :src="require('@/app/assets/img/logo.png')"
          contain
          position="left center"
        />
      </router-link>
    </v-toolbar-title>

    <template
      v-if="!isMobile && navigationLoaded"
      v-slot:extension
    >
      <v-tabs
        background-color="transparent"
        slider-color="#236365"
        light
        centered
      >
        <v-tab
          v-for="tab in items"
          :key="tab.id"
          :to="tab.path"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-progress-linear
        v-if="!isMobile && !navigationLoaded"
        color="#236365"
        height="2"
        indeterminate
      />
    </template>

    <v-spacer />
    <v-toolbar-items>
      <v-row
        v-if="!isMobile"
        class="pt-5 pr-4 flex-nowrap flex-column"
        no-gutters
      >
        <v-col>
          <span class="font-weight-bold">Darbo laikas: </span>
          <span
            class="font-weight-light"
            style="white-space: nowrap;"
          >{{
            darboLaikas
          }}</span>
        </v-col>
        <v-col>
          <span class="font-weight-bold">Tel. nr.: </span>
          <span class="font-weight-light">{{ telefonoNumeris }}</span>
        </v-col>
        <v-col>
          <span class="font-weight-bold">Adresas: </span>
          <span class="font-weight-light">{{ adresas }}</span>
        </v-col>
      </v-row>
      <v-row
        :class="isMobile ? 'pt-1 flex-nowrap' : 'pt-7'"
        no-gutters
      >
        <v-col>
          <v-btn
            v-if="isMobile"
            text
            color="#236365"
            href="tel:+37067272055"
            icon
            large
            class="call"
            @click="trackClick"
          >
            <v-icon large>
              phone
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            icon
            text
            color="#236365"
            href="https://www.facebook.com/DivetosVeterinarija"
            target="_blank"
            large
          >
            <v-icon large>
              fa-facebook-square
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-app-bar-nav-icon
            v-if="isMobile"
            @click="$emit('nav-toggle')"
          />
        </v-col>
      </v-row>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    darboLaikas: {
      type: String,
      default: ""
    },
    adresas: {
      type: String,
      default: ""
    },
    telefonoNumeris: {
      type: String,
      default: ""
    }
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    navigationLoaded() {
      return this.items.length > 0;
    }
  },
  methods: {
    toggleNav(event) {
      const targetElement = event.target.parentElement.parentElement;
      if (targetElement.nodeName === "LI") {
        targetElement.className =
          targetElement.className === "open" ? "" : "open";
      }

      event.preventDefault();
    },
    trackClick() {
      this.$ga.event("siteActions", "clickCall", "clickCall", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  margin-top: 30px;
  height: 100px;
  width: 200px;
}
.mobileLogo {
  height: 60px;
  width: 120px;
}
@-webkit-keyframes swing {
  20% {
    -webkit-transform: rotate3d(0, 0, 1, 15deg);
    transform: rotate3d(0, 0, 1, 15deg);
  }

  40% {
    -webkit-transform: rotate3d(0, 0, 1, -10deg);
    transform: rotate3d(0, 0, 1, -10deg);
  }

  60% {
    -webkit-transform: rotate3d(0, 0, 1, 5deg);
    transform: rotate3d(0, 0, 1, 5deg);
  }

  80% {
    -webkit-transform: rotate3d(0, 0, 1, -5deg);
    transform: rotate3d(0, 0, 1, -5deg);
  }

  to {
    -webkit-transform: rotate3d(0, 0, 1, 0deg);
    transform: rotate3d(0, 0, 1, 0deg);
  }
}

@keyframes swing {
  20% {
    -webkit-transform: rotate3d(0, 0, 1, 15deg);
    transform: rotate3d(0, 0, 1, 15deg);
  }

  40% {
    -webkit-transform: rotate3d(0, 0, 1, -10deg);
    transform: rotate3d(0, 0, 1, -10deg);
  }

  60% {
    -webkit-transform: rotate3d(0, 0, 1, 5deg);
    transform: rotate3d(0, 0, 1, 5deg);
  }

  80% {
    -webkit-transform: rotate3d(0, 0, 1, -5deg);
    transform: rotate3d(0, 0, 1, -5deg);
  }

  to {
    -webkit-transform: rotate3d(0, 0, 1, 0deg);
    transform: rotate3d(0, 0, 1, 0deg);
  }
}

.call {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-animation-name: swing;
  animation-name: swing;
  animation-delay: 2s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: 4;
  animation-iteration-count: 4;
}
</style>
